// Core
import React, { useState, useRef, useEffect } from 'react';
import { Flex, Button, Box, Image, Grid, Text, Spinner, useDisclosure } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { FaTelegramPlane } from 'react-icons/fa';
import { useQuery } from 'react-query';
import { SiCrystal } from 'react-icons/si';

// Assets
import { apiService } from 'services/ApiService';
import { parseMessageDate } from 'services/Utils';
import placeholderUser from 'assets/img/placeholder-user.png';
import { textLang } from 'services/Lang';

// Components
import './Wheel.css';
import WonModal from './Modal';

const Games = () => {
	const [spinning, setSpinning] = useState(false);
	const [rotation, setRotation] = useState(90);

	const [sectors, setSectors] = useState(12);
	
	const [gameError, setGameError] = useState(false);
	const { data: game, isFetching } = useQuery({
    queryKey: ['game'],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response = await apiService.gameInfo();
      if(new Date(game?.nextSpinDate) > new Date()){
      		setGameError(true);
      }

      return response.data;
    },
    retry: false
  });

	const [winningIndex, setWinningIndex] = useState();
	const spinWheel = async () => {
	  if (spinning) { return; }
	  setSpinning(true);

	  try {
	  	const response = await apiService.gamePlay();
	  	if(response.data === false || response.statusCode !== 200){
        setSpinning(false);
        setGameError(true);
	    	onOpen();
        return;
      }

      const winningIndexPlay = response.data.winningIndex;
		  setWinningIndex(winningIndexPlay);

		  const sectorAngle = 360 / sectors;
	    const stopAngle = 360 - (winningIndexPlay * sectorAngle + sectorAngle / 2);

	    const finalRotation = rotation + 360 * 5 + stopAngle;
	    setRotation(finalRotation + 15);
	 
		  setTimeout(() => {
		    setSpinning(false);
		    onOpen();
		  }, 5000);
    } catch(e){
      setSpinning(false);
	    onOpen();
      return;
    }
	};

	const { isOpen, onClose, onOpen } = useDisclosure();

	const handleClaim = async () => {
	    onClose();
	    setRotation(90);
	};

	return (
		<Box mt="100px" p="24px 15px">
			<Box bg="white" borderRadius="16px" p="20px" border="1px solid #3182ceab">
				<Text variant="text-lg" textAlign="center" p="0 10px">
					{textLang('spin_wheel_header')}
				</Text>
			</Box>

			<Button onClick={spinWheel} variant="secondary-lg" borderRadius="full" px="16px !important" mt="16px" mb="16px">
	        	<Text as="span" pl="12px" color="white">{textLang('spin_wheel_btn')}</Text>
	    	</Button>

	    	<fieldset className="ui-wheel-of-fortune">
		    	<div
				    className="wheel"
				    style={{
				      transform: `rotate(${rotation}deg)`,
				      transition: spinning ? 'transform 5s cubic-bezier(0.33, 1, 0.68, 1)' : 'none'
				    }}
				>
				<ul>
				    { game && game?.sectors?.map((i, index) => (
					    <li key={index}>{i.valueString}</li>
					))}
				</ul>
			  </div>

			  <button type="button">
			  	<Box bg="white" p="12px" borderRadius="full" w="68px" h="68px" m="0 auto">
			  		<SiCrystal fontSize="44px" color="#0088cc" />
			  	</Box>
			  </button>
			</fieldset>

			<WonModal
			  handle={handleClaim}
			  isOpen={isOpen}
			  onClose={onClose}
			  error={gameError}
			  time={game?.nextSpinDate}
			  amount={game?.sectors[winningIndex]?.valueString}
			/>
		</Box>
	);
};

export default Games;